import { event } from 'jquery'
import React, { useEffect } from 'react'
import '../css/HomeBody.css'



function HomeBody() {
    document.querySelector('body').addEventListener('mousemove',
        (e) => rotateEye(e))
    function rotateEye(e) {
        var eyes = document.querySelectorAll('.homeEye')
        eyes.forEach(eye => {
            let x = eye.getBoundingClientRect().left + (
                eye.clientWidth / 2);
            let y = eye.getBoundingClientRect().top + (
                eye.clientHeight / 2);
            let radian = Math.atan2(e.pageX - x, e.pageY - y)
            let rotation = (radian * (180 / Math.PI) * -1) + 270;
            eye.style.transform = 'rotate(' + rotation + 'deg)'
        })
    }

    return (
        <div className='homebody'>
            <div className='homeLeft'>
                <p className='scriptTag1'>&lt;body&gt;</p>
                <p className='scriptTag2'>&lt;main&gt;</p>
                <div className='animateContent'>
                    <span>H</span>
                    <span>i</span>
                    <span>,</span>
                    <br />
                    <span>I</span>
                    <span>'</span>
                    <span>m</span>
                    <span> </span>
                    <span id='nameInitial'>S</span>
                    <span>h</span>
                    <span>a</span>
                    <span>k</span>
                    <span>t</span>
                    <span>h</span>
                    <span>i</span>
                    <span>,</span>
                    <br />
                    <span>D</span>
                    <span>e</span>
                    <span>v</span>
                    <span>e</span>
                    <span>l</span>
                    <span>o</span>
                    <span>p</span>
                    <span>e</span>
                    <span>r</span>
                    <span>.</span>

                    <h2 className='contentSub'>Web & Android Development</h2>
                </div>
                <p className='scriptTag3'> &lt;/main&gt;</p>
                <p className='scriptTag4'>&lt;/body&gt;</p>
                <p className='scriptTag5'>&lt;/html&gt;</p>
            </div>
            <div className='homeRight'>
                <div className='eyeContainer'>
                    <div className='homeEye'></div>
                    <div className='homeEye'></div>
                </div>
                <p className='circTxt'>
                    <span>H</span>
                    <span>e</span>
                    <span>y</span>
                    <span>, </span>
                    <span>W</span>
                    <span>e</span>
                    <span>l</span>
                    <span>c</span>
                    <span>o</span>
                    <span>m</span>
                    <span>e</span>
                </p>

            </div>
        </div>
    )
}

export default HomeBody
